const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true },
    { name: 'Chat', href: '/chatdashboard', icon: ChatBubbleBottomCenterIcon, current: false },
    { name: 'My Profile', href: '/myprofile', icon: UserIcon, current: false },
    { name: 'Organization', href: '/organizationaltree', icon: ScaleIcon, current: false },
    { name: 'Task Manager', href: '/taskcalendar', icon: ClipboardDocumentCheckIcon, current: false },
    { name: 'Analytics', href: '/analytics', icon: ChartBarIcon, current: false },
    { name: 'Training', href: '/training', icon: AcademicCapIcon, current: false },
    { name: 'Users', href: '/users', icon: UserGroupIcon, current: false },
    { name: 'Billing', href: '/billing', icon: WalletIcon, current: false },
    { name: 'Log Out', href: '/logout', icon: PowerIcon, current: false },
   
    ];
  
  
  import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
  import { useState } from 'react';
  import { Link } from 'react-router-dom';
  import { XMarkIcon } from '@heroicons/react/20/solid';
  import { CheckCircleIcon } from '@heroicons/react/20/solid';
  import { useEffect } from 'react';
  import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid'
  import { CursorArrowRaysIcon, EnvelopeOpenIcon, UsersIcon } from '@heroicons/react/24/outline'
  import TaskManager from '../manager/taskmanager';
  
  
  
  import { Bars3Icon, HomeIcon, UserIcon, ScaleIcon, ClipboardDocumentCheckIcon, ChartBarIcon, AcademicCapIcon, UserGroupIcon, WalletIcon, PowerIcon, ChatBubbleBottomCenterIcon } from '@heroicons/react/20/solid';
  import HeatMap  from '../manager/heatmap';
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  
  
  
  export default function TrainingStats() {
  
    const [sidebarOpen, setSidebarOpen] = useState(false);
  
    const token = localStorage.getItem('token');
  
    const [trainingStats, setTrainingStats] = useState([]); // Array of training result objects for staff who took the quiz
    const [missingTraining, setMissingTraining] = useState([]); // Array of objects for staff missing from a training
    const [teamMembers, setTeamMembers] = useState(0);
    const [loading, setLoading] = useState(true);
    const [graph, setGraph] = useState(null);
    const [trainingTitles, setTrainingTitles] = useState([]);
    
    const [handleReminder, setHandleReminder] = useState(false);
  
    // This state controls which training card is "open" (showing details)
    const [openTrainingId, setOpenTrainingId] = useState(null);
  
    useEffect(() => {
      // Fetch training statistics from your API endpoint
      const fetchStats = async () => {
        try {
          const response = await fetch('https://api.insightos.co.uk/api/trainingstatsme', {
            method: 'GET',
            headers: {
              "Content-Type": "application/json",
              },
              credentials: 'include',
          });
  
  
          const data = await response.json();
          if (data.success) {
            setTrainingStats(data.data);
  
            // find all the unique trainingTitles
  
            const trainingTitles = [...new Set(data.data.map((item) => item.trainingTitle))];
  
            // turn trainingTitles into an array of objects with a title property
  
            const trainingTitle = trainingTitles.map((title) => ({ title }));
  
  
  
            setTrainingTitles(trainingTitle.length);
  
            setMissingTraining(data.missingTraining);
            setTeamMembers(data.teamMembers);
          }
        } catch (error) {
          console.error('Error fetching training stats:', error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchStats();
    }, []);
  
    // Group the trainingStats by trainingId so that each card represents one training course.
    // Each group will have an array of results (each result represents one staff's attempt(s)).
    const groupedTrainings = trainingStats.reduce((acc, curr) => {
      const { trainingId, trainingTitle } = curr;
      if (!acc[trainingId]) {
        acc[trainingId] = { trainingTitle, results: [] };
      }
      acc[trainingId].results.push(curr);
      return acc;
    }, {});
  
    const trainingCards = Object.keys(groupedTrainings).map((trainingId) => ({
      trainingId,
      trainingTitle: groupedTrainings[trainingId].trainingTitle,
      results: groupedTrainings[trainingId].results,
    }));
  
    // For a given training course, find the list of staff who have taken it
    // and the list of staff missing it.
    const getTrainingDetails = (trainingId) => {
      // Staff who took the quiz for this training
      const taken = groupedTrainings[trainingId].results;
      // Missing: filter the missingTraining array by matching trainingId.
      const missing = missingTraining.filter((m) => m.trainingId == trainingId);
      return { taken, missing };
    };
  
    if (loading) {
      return <div>Loading training statistics...</div>;
    }
  
    
    
    
  
    
    const stats = [
      { id: 1, name: 'Staff Members', stat: teamMembers, icon: UsersIcon, change: '122', changeType: 'increase' },
      { id: 2, name: 'Courses', stat: trainingTitles, icon: EnvelopeOpenIcon, change: '5.4%', changeType: 'increase' },
    ]
    
      
  
     
  
  
    return (
    <>
    <div className="min-h-screen bg-gray-50">
      
    

     

        <main className="min-h-screen bg-white w-full overflow-y-auto">
      <div className="p-2 sm:p-4 lg:p-6">
        <h1 className="text-lg sm:text-2xl lg:text-3xl font-bold text-white p-3 sm:p-4 bg-emerald-500 mb-4 sm:mb-6 font-bebas rounded-lg">📊 Training Statistics</h1>
        <div>
  
        <dl className="mt-4 sm:mt-6 grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-2">
          {stats.map((item) => (
            <div
              key={item.id}
              className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow-lg hover:shadow-xl transition-shadow duration-200 sm:px-6 sm:pt-6 border border-gray-100"
            >
              <dt>
                <div className="absolute rounded-md bg-gradient-to-r from-indigo-500 to-purple-600 p-2 sm:p-3">
                  <item.icon aria-hidden="true" className="size-5 sm:size-6 text-white" />
                </div>
                <p className="ml-12 sm:ml-16 truncate text-xs sm:text-sm font-medium text-gray-600">{item.name}</p>
              </dt>
              <dd className="ml-12 sm:ml-16 flex items-baseline pb-6 sm:pb-7">
                <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">{item.stat}</p>
               
              </dd>
            </div>
          ))}
        </dl>
      </div>
     
        <div className="grid grid-cols-1 mt-6 gap-4 sm:gap-6">
          
          {trainingCards.map((card) => (
            <div key={card.trainingId} className="bg-gradient-to-r from-indigo-600 to-purple-700 shadow-lg rounded-lg p-4 sm:p-6 overflow-hidden hover:shadow-xl transition-all duration-200">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
                <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-white flex items-center">
                  🎓 {card.trainingTitle}
                </h2>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 mt-4">
                <button
                  onClick={() =>
                    setOpenTrainingId(
                      openTrainingId === card.trainingId ? null : card.trainingId
                    )
                  }
                  className="w-full sm:w-auto px-4 py-2 sm:py-3 bg-white text-indigo-700 rounded-lg hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-400 font-semibold transition-colors duration-200 shadow-md"
                >
                  {openTrainingId === card.trainingId ? '📋 Hide Details' : '👁️ View Details'}
                </button>
                <button 
                  onClick={() => setGraph(graph === card.trainingId ? null : card.trainingId)}
                  className="w-full sm:w-auto px-4 py-2 sm:py-3 bg-emerald-400 text-indigo-700 rounded-lg hover:bg-emerald-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-emerald-400 font-semibold transition-colors duration-200 shadow-md"
                >
                  {graph === card.trainingId ? '📊 Hide Graphs' : '📈 View Graphs'}
                </button>
              </div>
              {/* Graph Section */}
              {graph === card.trainingId && (
                <div className="mt-6 p-4 bg-white/10 rounded-lg backdrop-blur-sm">
                  <div className="overflow-x-auto">
                    <HeatMap trainingId={card.trainingId} trainingCards={trainingCards} />
                  </div>
                </div>
              )}

              {/* Details Section */}
              {openTrainingId === card.trainingId && (
                <div className="mt-6 flow-root">
                  <div className="overflow-hidden">
                    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                      <h3 className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 text-sm sm:text-base font-bold text-gray-900 border-b border-gray-200">
                        📊 Staff Attempts for {card.trainingTitle}
                      </h3>
                      
                      {/* Mobile Card View */}
                      <div className="block sm:hidden max-h-96 overflow-y-auto space-y-3 p-3">
                        {card.results
                          .flatMap((result) =>
                            result.attempts.map((attempt) => ({
                              staffName: result.staffName,
                              score: attempt.score,
                              attemptNumber: attempt.attempts,
                              createdAt: attempt.createdAt,
                              difficulty: attempt.difficulty,
                              questionNumber: attempt.questionNumber,
                            }))
                          )
                          .map((item, idx) => {
                            const isPass = parseInt(item.score) / parseInt(item.questionNumber) >= 0.8;
                            return (
                              <div key={idx} className={`rounded-lg p-4 shadow-sm border-2 ${
                                isPass ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'
                              }`}>
                                {/* Staff Name Header */}
                                <div className="flex justify-between items-start mb-3">
                                  <h4 className="font-bold text-gray-900 text-sm">
                                    👤 {item.staffName}
                                  </h4>
                                  <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                                    isPass ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                                  }`}>
                                    {isPass ? '✅ PASS' : '❌ FAIL'}
                                  </span>
                                </div>
                                
                                {/* Score Section */}
                                <div className="mb-3 p-3 bg-white rounded-md">
                                  <div className="flex justify-between items-center">
                                    <span className="text-xs font-medium text-gray-600">🎯 Score</span>
                                    <span className={`font-bold text-sm ${
                                      isPass ? 'text-green-600' : 'text-red-600'
                                    }`}>
                                      {parseInt(item.score)}/{parseInt(item.questionNumber)}
                                    </span>
                                  </div>
                                  <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                                    <div 
                                      className={`h-2 rounded-full transition-all duration-300 ${
                                        isPass ? 'bg-green-500' : 'bg-red-500'
                                      }`}
                                      style={{width: `${(parseInt(item.score) / parseInt(item.questionNumber)) * 100}%`}}
                                    ></div>
                                  </div>
                                </div>

                                {/* Details Grid */}
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="bg-white rounded-md p-2">
                                    <div className="text-xs text-gray-600 mb-1">🔢 Attempt</div>
                                    <div className="font-medium text-sm text-gray-900">#{item.attemptNumber}</div>
                                  </div>
                                  
                                  <div className="bg-white rounded-md p-2">
                                    <div className="text-xs text-gray-600 mb-1">⚡ Difficulty</div>
                                    <div className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full inline-block">
                                      {item.difficulty}
                                    </div>
                                  </div>
                                </div>

                                {/* Date Section */}
                                <div className="mt-3 pt-3 border-t border-gray-200 bg-white rounded-md p-2">
                                  <div className="text-xs text-gray-600 mb-1">📅 Date & Time</div>
                                  <div className="text-xs text-gray-900">
                                    <div>{new Date(item.createdAt).toLocaleDateString()}</div>
                                    <div className="text-gray-500">{new Date(item.createdAt).toLocaleTimeString()}</div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>

                      {/* Desktop Table View */}
                      <div className="hidden sm:block overflow-x-auto max-h-96 overflow-y-auto">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead className="bg-gray-100 sticky top-0 z-10">
                            <tr>
                              <th
                                scope="col"
                                className="py-2 sm:py-3.5 pl-3 sm:pl-4 pr-2 sm:pr-3 text-left text-xs sm:text-sm font-bold text-gray-900 whitespace-nowrap"
                              >
                                👤 Staff Name
                              </th>
                              <th
                                scope="col"
                                className="px-2 sm:px-3 py-2 sm:py-3.5 text-left text-xs sm:text-sm font-bold text-gray-900 whitespace-nowrap"
                              >
                                🎯 Score
                              </th>
                              <th
                                scope="col"
                                className="px-2 sm:px-3 py-2 sm:py-3.5 text-left text-xs sm:text-sm font-bold text-gray-900 whitespace-nowrap"
                              >
                                🔢 Attempt
                              </th>
                              <th
                                scope="col"
                                className="px-2 sm:px-3 py-2 sm:py-3.5 text-left text-xs sm:text-sm font-bold text-gray-900 whitespace-nowrap"
                              >
                                📅 Date
                              </th>
                              <th
                                scope="col"
                                className="px-2 sm:px-3 py-2 sm:py-3.5 text-left text-xs sm:text-sm font-bold text-gray-900 whitespace-nowrap"
                              >
                                ⚡ Difficulty
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 bg-white">
                            {card.results
                              .flatMap((result) =>
                                result.attempts.map((attempt) => ({
                                  staffName: result.staffName,
                                  score: attempt.score,
                                  attemptNumber: attempt.attempts,
                                  createdAt: attempt.createdAt,
                                  difficulty: attempt.difficulty,
                                  questionNumber: attempt.questionNumber,
                                }))
                              )
                              .map((item, idx) => (
                                <tr key={idx} className="hover:bg-gray-50 transition-colors duration-150">
                                  <td className="whitespace-nowrap py-3 sm:py-4 pl-3 sm:pl-4 pr-2 sm:pr-3 text-xs sm:text-sm font-medium text-gray-900">
                                    {item.staffName}
                                  </td>
                                  <td className={`whitespace-nowrap px-2 sm:px-3 py-3 sm:py-4 text-xs sm:text-sm font-bold 
                                    ${parseInt(item.score) / parseInt(item.questionNumber) >= 0.8 ? "text-emerald-600" : "text-red-600"}`}>
                                    <div className="flex flex-col sm:flex-row sm:items-center gap-1">
                                      <span>{parseInt(item.score)}/{parseInt(item.questionNumber)}</span>
                                      <span className={`text-xs px-2 py-1 rounded-full font-bold ${
                                        parseInt(item.score) / parseInt(item.questionNumber) >= 0.8 
                                        ? "bg-emerald-100 text-emerald-700" 
                                        : "bg-red-100 text-red-700"
                                      }`}>
                                        {parseInt(item.score) / parseInt(item.questionNumber) >= 0.8 ? "✅ PASS" : "❌ FAIL"}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="whitespace-nowrap px-2 sm:px-3 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 font-medium">
                                    #{item.attemptNumber}
                                  </td>
                                  <td className="whitespace-nowrap px-2 sm:px-3 py-3 sm:py-4 text-xs sm:text-sm text-gray-900">
                                    <div className="flex flex-col">
                                      <span>{new Date(item.createdAt).toLocaleDateString()}</span>
                                      <span className="text-xs text-gray-500">{new Date(item.createdAt).toLocaleTimeString()}</span>
                                    </div>
                                  </td>
                                  <td className="whitespace-nowrap px-2 sm:px-3 py-3 sm:py-4 text-xs sm:text-sm text-gray-900">
                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                      {item.difficulty}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      
                      {/* Task Manager Section */}
                      <div className="border-t border-gray-200 p-4 sm:p-6 bg-gray-50">
                        <div className="mb-4">
                          <TaskManager />
                        </div>

                        {/* Missing Staff Section */}
                        <div className="mt-6">
                          {missingTraining.filter((m) => m.trainingId == card.trainingId).length > 0 ? (
                            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                              <h3 className="text-base sm:text-lg font-bold text-red-800 mb-3 flex items-center">
                                ⚠️ Missing Staff ({missingTraining.filter((m) => m.trainingId == card.trainingId).length})
                              </h3>
                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                                {missingTraining
                                  .filter((m) => m.trainingId == card.trainingId)
                                  .map((m, index) => (
                                    <div key={index} className="bg-red-100 rounded-md px-3 py-2">
                                      <span className="text-sm font-medium text-red-800">{m.staffName}</span>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          ) : (
                            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                              <p className="text-sm sm:text-base text-green-800 font-medium flex items-center">
                                ✅ All staff have completed this training
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
        </main>
    </div>
    </>
  );
}
  